import React, { useEffect, useRef } from "react";

const apiKey = process.env.REACT_APP_API_KEY;

const loadGoogleMapsScript = (callback) => {
  if (
    typeof window.google === "object" &&
    typeof window.google.maps === "object" &&
    typeof window.google.maps.LatLngBounds === "function"
  ) {
    callback();
    return;
  }

  // Handle Google Maps auth warnings gracefully in DEV
  window.gm_authFailure = () => {
    console.warn("Google Maps API Warning: Inserire REACT_APP_API_KEY per attivare i servizi completi.");
  };

  const existingScript = document.querySelector(`script[src*="maps.googleapis.com/maps/api/js"]`);

  const onScriptReady = () => {
    const interval = setInterval(() => {
      if (
        typeof window.google === "object" &&
        typeof window.google.maps === "object" &&
        typeof window.google.maps.LatLngBounds === "function"
      ) {
        clearInterval(interval);
        callback();
      }
    }, 50);
  };

  if (!existingScript) {
    window.initGoogleMapCallback = () => {
      onScriptReady();
    };

    const keyQueryParam = apiKey ? `key=${apiKey}&` : '';
    const script = document.createElement("script");
    script.src = `https://maps.googleapis.com/maps/api/js?${keyQueryParam}libraries=places&callback=initGoogleMapCallback`;
    script.async = true;
    script.defer = true;
    script.onload = onScriptReady;
    document.head.appendChild(script);
  } else {
    existingScript.addEventListener("load", onScriptReady);
    onScriptReady();
  }
};

const GoogleMap = ({ coordinates = [], markerCoords = [], address, NoHighlight }) => {
  const mapRef = useRef(null);

  useEffect(() => {
    let isMounted = true;

    loadGoogleMapsScript(() => {
      if (!isMounted) return;
      const google = window.google;
      if (!google || !google.maps || typeof google.maps.LatLngBounds !== "function") return;

      if (!mapRef.current) return;
      if (!coordinates || coordinates.length === 0) return;

      const bounds = new google.maps.LatLngBounds();

      // Extend bounds to include all coordinates
      coordinates.forEach((coord) => {
        if (coord && typeof coord.lat === 'number' && typeof coord.lng === 'number') {
          bounds.extend(new google.maps.LatLng(coord.lat, coord.lng));
        }
      });

      const map = new google.maps.Map(mapRef.current, {
        zoom: 10,
        center: bounds.getCenter(),
      });
      map.fitBounds(bounds);

      if (Array.isArray(markerCoords)) {
        markerCoords.forEach((marker) => {
          if (Array.isArray(marker) && marker.length >= 2) {
            const markerObj = new google.maps.Marker({
              position: { lat: Number(marker[0]), lng: Number(marker[1]) },
              map: map,
            });

            if (marker[2]) {
              const infoWindow = new google.maps.InfoWindow({
                content: `<div style="color: black;">${marker[2]}</div>`,
              });

              markerObj.addListener("click", () => {
                infoWindow.open(map, markerObj);
              });
            }
          }
        });
      }
    });

    return () => {
      isMounted = false;
    };
  }, [coordinates, markerCoords, address, NoHighlight]);

  return <div ref={mapRef} style={{ width: "90%", height: "90%", minHeight: "350px" }} />;
};

export default GoogleMap;
